module.exports = __webpack_public_path__ + "img/brasov.cb8e2fda.jpg";